// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-arrow-up-icon lucide-arrow-up\"><path d=\"m5 12 7-7 7 7\"/><path d=\"M12 19V5\"/></svg>";
// Exports
module.exports = code;